import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/designThemes.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { DESIGN_THEME_STORAGE_KEY, DEFAULT_DESIGN_THEME } from './constants/designThemes';

const savedDesignTheme = localStorage.getItem(DESIGN_THEME_STORAGE_KEY) || DEFAULT_DESIGN_THEME;
document.documentElement.setAttribute('data-design-theme', savedDesignTheme);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
